import altriaLogo from 'Assets/icon_altria.png';
import rjrLogo from 'Assets/icon_rjr.png';
import itgLogo from 'Assets/icon_itg.png';

export const PARTNER_KEYS = ['ALTRIA', 'RJR', 'ITG'];

export const PARTNER_LABEL = {
  ALTRIA: 'Altria',
  RJR: 'RJR',
  ITG: 'ITG'
};

export const PARTNER_LOGO = {
  ALTRIA: altriaLogo,
  RJR: rjrLogo,
  ITG: itgLogo
};

export function normalizePartner(value) {
  if (!value || typeof value !== 'string') return null;
  const upper = value.toUpperCase();
  return PARTNER_KEYS.includes(upper) ? upper : null;
}

export function isValidPartner(key) {
  return normalizePartner(key) !== null;
}
